<template>
<div>
<div class="grid">
<div class="col-10 md:col-10">
<span class="p-float-label mb-4 mt-2" v-show="data.show">
  <InputText :id="data.key" type="text" v-model="inputdata" class="w-full p-inputtext-sm" :class="{'p-invalid':data.has_error }"  v-on:keydown.enter.prevent="addOption" />
  <label :for="data.key"  :class="{'hidden':data.has_error }">{{data.title}}</label>
  <small :id="data.key+'-help'" class="p-error pt-2" v-if="data.has_error"><b> {{data.title}}</b> {{data.error_message}}</small>
</span>
</div>
<div class="col-2 md:col-2">
  <Button type="button"  icon="pi pi-check" @click="addOption" class="p-button-primary p-button-outlined p-button-sm mr-2 mt-2"  />
</div>

</div>


<div class="flex align-items-center flex-column sm:flex-row">
  <Chip v-for="(item) in options" :label="item.name" class="mr-2 mb-2" :key="item.id" removable @remove="removeItem(item.id)" />
</div>

</div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {

  name: 'InputChipsValidate',
  props:["data","fieldindex"],
  data () {
    return {
    	inputdata:null,
      options:[],
    }
  },
  computed:{
  	dataValue()
  	{
      return  this.data.value
  	}
  },
  watch:{
  	async dataValue(newVal,oldVal)
  	{

  		this.options =await this.dataValue
  	}
  },
  methods:{
    removeItem(id)
    {
      
      let leftover = JSON.parse(JSON.stringify(this.options)).filter((item)=>{return item.id !== id})    
      this.options = leftover
      setTimeout(()=>{
        this.emitValue()
      },100)
      
    },
    async addOption()
    {
      let last_ind = 0
      if(this.options.length>0)
      {
        last_ind = this.options[this.options.length-1].id+1
      }
      await this.options.push({name:this.inputdata,id:last_ind})      
      await this.emitValue()
      this.inputdata = await null

    },
  	emitValue()
  	{
  		this.$emit("emitValue",{value:this.options,index:this.fieldindex})
  	},
  }
};
</script>

<style lang="css" scoped>
</style>